import { Fragment } from "react";
import Banner from "./banner/Banner";
import OptionList from "./optionList/OptionList";
import CustomText from "./customText/CustomText";
import GenerateButton from "./generateButton/GenerateButton";
import useGeneration from "@/views/generation/hooks/useGeneration";
import { StyledContainer } from "./SelectRange.styles";

const SelectRange = () => {
  const {
    selectedEdu,
    selectedSubject,
    selectedVolume,
    selectedChapter,
    selectedSubChapter,
    eduOptions,
    subjectOptions,
    volumeOptions,
    chapterOptions,
    subChapterOptions,
    customText,
    setSelectedEdu,
    setSelectedSubject,
    setSelectedVolume,
    setSelectedChapter,
    setSelectedSubChapter,
    setCustomText,
  } = useGeneration();

  const blocks = [
    {
      id: "edu",
      visible: (eduOptions?.length ?? 0) > 0,
      render: (num: number) => (
        <OptionList
          number={num}
          title="選擇學制"
          options={eduOptions ?? []}
          selectedValue={selectedEdu}
          onSelect={(value) => setSelectedEdu(value as string)}
        />
      ),
    },
    {
      id: "subject",
      visible: (subjectOptions?.length ?? 0) > 0,
      render: (num: number) => (
        <OptionList
          number={num}
          title="選擇科目"
          options={subjectOptions ?? []}
          selectedValue={selectedSubject}
          onSelect={(value) => setSelectedSubject(value as string)}
        />
      ),
    },
    {
      id: "volume",
      visible: (volumeOptions?.length ?? 0) > 0,
      render: (num: number) => (
        <OptionList
          number={num}
          title="選擇冊次"
          options={volumeOptions ?? []}
          selectedValue={selectedVolume}
          onSelect={(value) => setSelectedVolume(value as string)}
        />
      ),
    },
    {
      id: "chapter",
      visible: (chapterOptions?.length ?? 0) > 0,
      render: (num: number) => (
        <OptionList
          number={num}
          title="選擇章節"
          options={chapterOptions ?? []}
          selectedValue={selectedChapter}
          onSelect={(value) => setSelectedChapter(value as string)}
        />
      ),
    },
    {
      id: "subChapter",
      visible: (subChapterOptions?.length ?? 0) > 1,
      render: (num: number) => (
        <OptionList
          number={num}
          title="選擇對應的小節"
          options={subChapterOptions ?? []}
          selectedValue={selectedSubChapter}
          onSelect={(value) => setSelectedSubChapter(value as string)}
        />
      ),
    },
    {
      id: "customText",
      visible: true,
      render: (num: number) => (
        <CustomText
          number={num}
          title="自訂文本"
          value={customText}
          onChange={setCustomText}
        />
      ),
    },
  ];

  return (
    <StyledContainer>
      <Banner />
      {blocks
        .filter((b) => b.visible)
        .map((block, index) => (
          <Fragment key={block.id}>{block.render(index + 1)}</Fragment>
        ))}
      <GenerateButton />
    </StyledContainer>
  );
};

export default SelectRange;
